import type { Artwork } from "#models/artwork"
import type { FreshShoppingCart, OptimisticShoppingCart, ShoppingCart } from "#models/shopping/shoppingCart"

import Cookies from "js-cookie"

import { ShippingStatus } from "#models/shopping/shippingStatus"

export const SC_IDENTIFIER = "sc_id"

class ShoppingCartService {
  hasItem(shoppingCart: ShoppingCart | undefined, artworkId: number) {
    if (!shoppingCart) return false

    return shoppingCart.cartItems.filter(cartItem => cartItem.artwork.id === artworkId).length !== 0
  }

  /**
   * Calculates a new shoppingCart optimistically with an artwork
   */
  optimisticAddItem(shoppingCart: ShoppingCart | undefined, artwork: Artwork): ShoppingCart {
    return {
      type: "optimistic",
      cartHash: "",
      subtotal: 0,
      shippingCost: 0,
      total: 0,
      ...shoppingCart,
      cartItems: [...(shoppingCart?.cartItems ?? []), { artwork: artwork, active: true, quantity: 1, shipping_status: ShippingStatus.pending, pending: true }],
    }
  }

  /**
   * Calculates a new shoppingCart optimistically with removing an artwork
   */
  optimisticRemoveItem(shoppingCart: ShoppingCart, artworkId: number): ShoppingCart {
    const newCart = { ...(shoppingCart as FreshShoppingCart), type: "optimistic" } as OptimisticShoppingCart
    newCart.cartItems = newCart.cartItems.filter(item => item.artwork.id !== artworkId)
    return newCart
  }

  resetCartHash() {
    Cookies.remove(SC_IDENTIFIER)
  }

  getCartHash() {
    return Cookies.get(SC_IDENTIFIER)
  }
}

export const cartServiceClient = new ShoppingCartService()
